export default {
  methods: {
    localStorageSet(key, data) {
      localStorage.setItem(key, JSON.stringify(data));
    },
    localStorageGet(key, defaultValue) {
      let data = localStorage.getItem(key);

      if (data) {
        data = JSON.parse(data);
      } else {
        data = defaultValue;
      }

      return data;
    },
    localStorageDelete(key) {
      localStorage.removeItem(key);
    },
  },
};
